import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type EncoderStatusData = {
    messages: number;
    messagesRate: number;
    currentReplicas: number;
    desiredReplicas: number;
};

const initialState: Record<string, EncoderStatusData> = {
    video: {
        messages: 0,
        messagesRate: 0,
        currentReplicas: 0,
        desiredReplicas: 0,
    },
    audio: {
        messages: 0,
        messagesRate: 0,
        currentReplicas: 0,
        desiredReplicas: 0,
    },
};

const encoderStatusSlice = createSlice({
    name: 'encoderStatus',
    initialState,
    reducers: {
        encoderVideoStatus(state, action: PayloadAction<EncoderStatusData>) {
            state.video = { ...state.video, ...action.payload };
        },
        encoderAudioStatus(state, action: PayloadAction<EncoderStatusData>) {
            state.audio = { ...state.audio, ...action.payload };
        },
    },
});

export const { encoderVideoStatus, encoderAudioStatus } = encoderStatusSlice.actions;

export default encoderStatusSlice;
